import { useEffect, useCallback, useMemo } from 'react';
import { getPageEnterOrExitPayload, WEB_SOCKET_ACTION_TYPES } from '../utils/WebSocketUtils';

export function useWebSocketListener({ socketContext, onMessage, entityName, entityIds }) {
	const entityIdsKey = useMemo(() => JSON.stringify(entityIds), [entityIds]);

	const sendMessage = useCallback(
		(message) => {
			const { sendMessage, socket } = socketContext;

			if (!sendMessage) return false;
			if (socket && socket.readyState !== WebSocket.OPEN) return false;

			try {
				const res = sendMessage(message);
				return res || true;
			} catch {
				return false;
			}
		},
		[socketContext]
	);

	// Attach listener + join
	useEffect(
		() => {
			const { socket } = socketContext;
			if (!socket) return;
			if (!entityIds.length) return;

			// Attach listener
			socket.removeEventListener('message', onMessage);
			socket.addEventListener('message', onMessage);

			// SEND JOIN
			const joinMessage = getPageEnterOrExitPayload(
				entityIds,
				WEB_SOCKET_ACTION_TYPES.JOIN,
				entityName
			);

			sendMessage(joinMessage);

			return () => {
				// SEND LEFT
				const leftMessage = getPageEnterOrExitPayload(
					entityIds,
					WEB_SOCKET_ACTION_TYPES.LEFT,
					entityName
				);

				sendMessage(leftMessage);

				socket.removeEventListener('message', onMessage);
			};
		},
		//Having this both alone as dependency is very important
		//Otherwise multiple join and left call will be initiated
		[entityIdsKey, socketContext]
	);
}
